import { MainFormState } from '../../../types/forms/form.def';

export const getErrors = (
  errors: MainFormState<any>['errors'],
  field: string,
  errorMessage: string
) => ({
  ...errors,
  [field]: errorMessage || false
});
